/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_admin_severity_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Severity`)
};

const es_admin_severity_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gravedad`)
};

const de_admin_severity_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schweregrad`)
};

const nl_admin_severity_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ernst`)
};

const fr_admin_severity_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gravité`)
};

const it_admin_severity_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gravità`)
};

const pt_br2_admin_severity_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gravidade`)
};

const pt_admin_severity_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gravidade`)
};

const ja_admin_severity_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重大度`)
};

const zh_admin_severity_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`严重程度`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const admin_severity_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.admin_severity_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("admin_severity_placeholder", locale)
	if (locale === "en") return en_admin_severity_placeholder(inputs)
	if (locale === "es") return es_admin_severity_placeholder(inputs)
	if (locale === "de") return de_admin_severity_placeholder(inputs)
	if (locale === "nl") return nl_admin_severity_placeholder(inputs)
	if (locale === "fr") return fr_admin_severity_placeholder(inputs)
	if (locale === "it") return it_admin_severity_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_admin_severity_placeholder(inputs)
	if (locale === "pt") return pt_admin_severity_placeholder(inputs)
	if (locale === "ja") return ja_admin_severity_placeholder(inputs)
	return zh_admin_severity_placeholder(inputs)
};